import React, {useEffect, useState} from 'react'
import Button from '@material-ui/core/Button'

import {
  withDataProvider,
  showNotification,
  GET_LIST
} from 'react-admin'

import { createStyles, WithStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { ASSIGN_EXPERT } from '../../providers/constants'
import UsersSelect from '../UsersSelect'
import FormDialog from "../FormDialog";
import DeactivateSegmentModal from "../../components/Segments/DeactivateSegmentModal";


const styles = () => createStyles({
  wrap: {
    display: 'flex',
    width: '700px',
    marginBottom: '20px',
  },
  elements: {
    marginRight: '25px',
  },
  buttonWrap: {
    width: '596px',
    textAlign: 'right',
  },
  textAreaWrap: {
    marginBottom: '15px',
  },
  button: {
    marginRight: '15px'
  },
})

const responseSuccess = {
  onSuccess: {
    notification: { body: 'Сохранено', level: 'info' },
  },
  onFailure: {
    notification: { body: 'Error', level: 'warning' },
  },
  refresh: true
}

const ToolbarDirectorMo = withStyles(styles)(({classes, dataProvider, dispatch, statusId, specializationId, disabled, segments, checkedData}: any) => {

  const [users, setUsers] = useState([])

  const assignExpert = async (statusId, selectId, successText: boolean | string = false) => {
    const currentUserId = (document.getElementById(selectId) as HTMLInputElement).value as unknown

    if (currentUserId > 0) {
      await dataProvider(ASSIGN_EXPERT, 'segments', {
        segmentId: segments,
        data: {
          toUserId: currentUserId,
          status: 'assign',
          segmentStatusId: statusId // id assign
        }
      }, successText ? {
        onSuccess: {
          notification: { body: successText, level: 'info' },
        },
        onFailure: {
          notification: { body: 'Error', level: 'warning' },
        },
        refresh: true
      } : responseSuccess)
    } else {
      dispatch(showNotification('Эксперт не выбран', 'warning'))
    }
  }

  const checkNewExpert = async selectId => {
    const newExpert = (document.getElementById(selectId) as HTMLInputElement).value as unknown
    const error = []
    let checked = false

    // const segmentInfo = await dataProvider(GET_LIST, 'segments', {
    //   filter: { id: segments.join(',') },
    //   url: 'segments'
    // })

    // segmentInfo.data.map((segment, key) => {
    //   segment.experts.map(item => {
    //     if (item.id as number == newExpert as number) {
    //       checked = true
    //       error.push(`Данный пользователь уже проверял сегмент №${segment.id}, подтвердите повторное назначение эксперта.`)
    //     }
    //   })
    //   if (segment.verifyStatusId === 2) {
    //     error.push(`Cегмент №${segment.id} находится в работе, вы уверены что хотите его переназначить?`)
    //   }
    // })

    return {
      result: checked,
      error,
    }
  }

  /**
   * Получает список пользователей по фильтру.
   * @param filter
   */
  const getUsers = async filter => {
    const result = await dataProvider(GET_LIST, 'users', {filter: filter})
    setUsers(result.data)
  }

  /**
   * Перевести в указанный статус.
   * @param statusId
   * @param successText
   */
  const setStatus = async (statusId, successText: boolean | string = false) => {
    let isValid = true

    if (segments.length > 1) {
      const checkedItems: Array<ISegment> = Object.values(checkedData)
      isValid = checkedItems.every(({ statusId }, i, array) => statusId === array[0].statusId)
    }

    if (isValid) {
      dataProvider(ASSIGN_EXPERT, 'segments', {
        segmentId: segments,
        data: {
          status: 'assign',
          segmentStatusId: statusId
        }
      }, { onSuccess: { refresh: true } }).then(() => {
        dispatch(showNotification(successText))
      }).catch(error => {
        dispatch(showNotification(error, 'warning'))
      })
    } else {
      dispatch(showNotification('Сегменты должны быть в одном статусе.', 'warning'))
    }
  }

  return (
    <>
      {statusId === 1 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
            onBeforeOpenModal={() => getUsers({specializationId: specializationId, role: 'expertReviewer', status: 'active'})}
          />
          <Button onClick={() => setStatus(4, 'Переведено на проверку')} color="primary" className={classes.button} disabled={disabled}>На проверку</Button>
          <DeactivateSegmentModal buttonDisabled={disabled} segmentId={segments} />
        </>
      )}

      {statusId === 4 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
            onBeforeOpenModal={() => getUsers({specializationId: specializationId, role: 'expertReviewer', status: 'active'})}
          />
          <FormDialog
            label="Назначить НМО"
            modalTitle="Назначить НМО"
            content={<UsersSelect data={users} id="users-select-nmo" />}
            confirm={() => assignExpert(8, 'users-select-nmo')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-nmo')}
            onBeforeOpenModal={() => getUsers({role: 'directorMo', status: 'active'})}
          />
          <Button onClick={() => setStatus(1, 'Возвращено в статус "Новый"')} className={classes.button} disabled={disabled}>Вернуть</Button>
          <DeactivateSegmentModal buttonDisabled={disabled} segmentId={segments} />
        </>
      )}

      {statusId === 8 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
            onBeforeOpenModal={() => getUsers({specializationId: specializationId, role: 'expertReviewer', status: 'active'})}
          />
          <FormDialog
            label="Назначить корректора"
            modalTitle="Назначить корректора"
            content={<UsersSelect data={users} id="users-select-editors" />}
            confirm={() => assignExpert(7, 'users-select-editors')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-editors')}
            onBeforeOpenModal={() => getUsers({role: 'editor', status: 'active'})}
          />
          <Button onClick={() => setStatus(9, 'Возвращено на утверждение')} color="primary" className={classes.button} disabled={disabled}>На утверждение</Button>
          <Button onClick={() => setStatus(4, 'Возвращено на проверку')} className={classes.button} disabled={disabled}>Вернуть</Button>
          <DeactivateSegmentModal buttonDisabled={disabled} segmentId={segments} />
        </>
      )}

      {statusId === 7 && (
        <>
          <FormDialog
            label="Назначить главного методиста"
            modalTitle="Назначить главного методиста"
            content={<UsersSelect data={users} id="users-select-mainNmo" />}
            confirm={() => assignExpert(9, 'users-select-mainNmo')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-mainNmo')}
            onBeforeOpenModal={() => getUsers({role: 'methodist', status: 'active'})}
          />
          <Button onClick={() => setStatus(8, 'Возвращено на согласование')} className={classes.button} disabled={disabled}>Вернуть</Button>
          <DeactivateSegmentModal buttonDisabled={disabled} segmentId={segments} />
        </>
      )}

      {statusId === 9 && (
        <>
          <FormDialog
              label="Назначить главного методиста"
              modalTitle="Назначить главного методиста"
              content={<UsersSelect data={users} id="users-select-mainNmo" />}
              confirm={() => assignExpert(9, 'users-select-mainNmo')}
              className={classes.button}
              disabled={disabled}
              onBeforeConfirm={() => checkNewExpert('users-select-mainNmo')}
              onBeforeOpenModal={() => getUsers({role: 'methodist', status: 'active'})}
          />
          <Button onClick={() => setStatus(10, 'Сегмент утвержден')} color="primary" variant="outlined" className={classes.button} disabled={disabled}>Утвердить</Button>
          <Button onClick={() => setStatus(7, 'Возвращено на рецензирование')} className={classes.button} disabled={disabled}>Вернуть</Button>
          <DeactivateSegmentModal buttonDisabled={disabled} segmentId={segments} />
        </>
      )}

      {statusId === 10 && (
        <>
          <FormDialog
            label="Назначить НМО"
            modalTitle="Назначить НМО"
            content={<UsersSelect data={users} id="users-select-nmo" />}
            confirm={() => assignExpert(8, 'users-select-nmo')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-nmo')}
            onBeforeOpenModal={() => getUsers({role: 'directorMo', status: 'active'})}
          />
          <Button onClick={() => setStatus(9, 'Возвращено на утверждение')} color="primary" className={classes.button} disabled={disabled}>Вернуть</Button>
          <Button onClick={() => setStatus(11, 'Переведено в статус "На экзамен"')} className={classes.button} disabled={disabled}>На экзамен</Button>
        </>
      )}

      {statusId === 11 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
            onBeforeOpenModal={() => getUsers({specializationId: specializationId, role: 'expertReviewer', status: 'active'})}
          />
          <FormDialog
            label="Назначить НМО"
            modalTitle="Назначить НМО"
            content={<UsersSelect data={users} id="users-select-nmo" />}
            confirm={() => assignExpert(8, 'users-select-nmo')}
            className={classes.button}
            disabled={disabled}
            onBeforeConfirm={() => checkNewExpert('users-select-nmo')}
            onBeforeOpenModal={() => getUsers({role: 'directorMo', status: 'active'})}
          />
          <Button onClick={() => setStatus(10, 'Сегмент утвержден')} color="primary" className={classes.button} disabled={disabled}>В утверждённые</Button>
          <DeactivateSegmentModal buttonDisabled={disabled} segmentId={segments} />
        </>
      )}
    </>
  )
})

export default withDataProvider(ToolbarDirectorMo)
